import { catchError, of, OperatorFunction } from 'rxjs';
import { ErrorPage } from '../../services/generic-error/error-page-utils';
import { ErrorService } from '../../services/generic-error/error.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

export function withCatchErrorSideEffects<T>(
    errorService: ErrorService,
    loggerService: LoggerService,
): OperatorFunction<T, T> {
    return catchError((error) => {
        loggerService.error('Resolver error:', error.message);
        errorService.showError(ErrorPage.TECH_DIFF);
        return of(error);
    });
}
